import type { JSX } from "react";
import { StandardSection } from "./StandardSection";
import { MobileOnly, NotMobile } from "./Breakpoints";
import { FC } from "react";
import styled from "styled-components";

interface Props {
  pt?: string;
  pb?: string;
  background?: string;
  backgroundTop?: string;
  backgroundBottom?: string;
  cardColor?: string;
  maxWidth?: string;
  positionedElement?: JSX.Element;
}

export const Card: FC<React.PropsWithChildren<Props>> = ({
  pt,
  pb,
  background,
  backgroundTop,
  backgroundBottom,
  cardColor = "#956AFF",
  maxWidth = "80rem",
  positionedElement,
  children,
}) => (
  <>
    <MobileOnly>
      <StandardSection background={cardColor} pt="5rem" pb="5rem">
        {children}
      </StandardSection>
    </MobileOnly>
    <NotMobile>
      <Background
        backgroundTop={backgroundTop || background}
        backgroundBottom={backgroundBottom || background}
      >
        <StandardSection pt={pt} pb={pb} maxWidth={maxWidth}>
          <Relative>
            {positionedElement ? positionedElement : null}
            <CardContainer background={cardColor}>{children}</CardContainer>
          </Relative>
        </StandardSection>
      </Background>
    </NotMobile>
  </>
);

const Background = styled.section<{
  backgroundTop?: string;
  backgroundBottom?: string;
}>`
  background: linear-gradient(
    ${(p) => p.backgroundTop || "transparent"} 50%,
    ${(p) => p.backgroundBottom || "transparent"} 50%
  );
`;

const Relative = styled.div`
  position: relative;
`;

const CardContainer = styled.div<{ background: string }>`
  background: ${(p) => p.background};
  padding: 5rem 6rem;
  border-radius: 0.5rem;

  @media only screen and (max-width: 65rem) {
    padding: 3.5rem;
  }

  @media only screen and (max-width: 45rem) {
    padding: 2rem 1.75rem;
    border-radius: 0;
  }
`;
